import React, { useEffect, useState } from 'react';
import { FaLayerGroup, FaInfoCircle } from 'react-icons/fa';
// Removed direct Modal usage; using dedicated GuideModal component
import Table from './components/Table/Table';
import GuideModal from './components/GuideModal/GuideModal';
import { GetAllSelectionGroupsByLocalId } from '../../../../crud/menu_api/selection_groups';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import './SelectionGroups.scss';

interface SelectionGroupType {
  readonly selection_group_id: number;
  selection_group_name: string;
  selection_group_description?: string;
  local_id: number;
  separate_printing?: boolean;
  items_affected?: Array<{
    item_id: number;
    item_name: string;
  }>;
  items_contained?: Array<{
    item_id: number;
    item_name: string;
  }>;
}

const SelectionGroups: React.FC = () => {
  const [selectionGroups, setSelectionGroups] = useState<SelectionGroupType[]>([]);
  const [loading, setLoading] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);

  useEffect(() => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const local_id = user ? user.local_id : 0;

    GetAllSelectionGroupsByLocalId(local_id)
      .then((response) => {
        setSelectionGroups(response.data);
      })
      .catch((error) => {
        console.error('Error fetching selection groups', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const renderHeader = () => (
    <div className="selection-groups-header">
      <div className="header-content">
        <div className="title-section">
          <FaLayerGroup className="title-icon" />
          <div className="title-text">
            <h1>Combos y Extras</h1>
            <p>Crea grupos de opciones para que tus clientes personalicen sus pedidos</p>
          </div>
        </div>

        <div className="header-actions">
          <button 
            className="info-button"
            onClick={() => setShowHelpModal(true)}
          >
            <FaInfoCircle />
            <span>¿Cómo funciona?</span>
          </button>
        </div>
      </div>

      {/* Información explicativa */}
      <div className="explanation-banner">
        <div className="banner-content">
          <div className="banner-text">
            <h3>¿Qué son los Combos y Extras?</h3>
            <p>
              Los Combos y Extras te permiten crear grupos de opciones adicionales para tus productos físicos,
              con costo e inventario, de forma que tus clientes puedan personalizar sus pedidos.
              Con ellos puedes ofrecer complementos como queso extra, papas fritas, bebidas o acompañamientos, 
              así como armar combos que agreguen más valor a cada compra, mejorando la experiencia del cliente.
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  // Help modal now handled by GuideModal component

  if (loading) {
    return <LoadingSpinner text="Cargando tus combos y extras..." transparent={true} />;
  }

  return (
    <div className="selection-groups-container">
      {renderHeader()}
      <Table data={selectionGroups} setData={setSelectionGroups} />
  <GuideModal show={showHelpModal} onClose={() => setShowHelpModal(false)} />
    </div>
  );
};

export default SelectionGroups;
